exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scn-btn[data-v-65f3a501] {\n  position: -webkit-sticky;\n  position: sticky;\n  z-index: 1;\n  margin-left: auto;\n  margin-bottom: 5px;\n  top: 55px;\n}\n.text-editor[data-v-65f3a501] {\n  position: relative;\n}\n", ""]);

// exports
